











































import PurchaseOptions from '~/components/globals/product/purchase-options'

export default

	components: { PurchaseOptions }

	props:
		product: Object
		currentVariant: Object
		loading: Boolean

	data: ->
		adding: false # Add to cart loading state
		choices: {}
		scroller: null
		purchaseType: 'once'

	computed:
		productDisclaimer: -> @$store.state.globals.productFields?.disclaimer
		shippingMessage: -> @$store.state.globals.productFields?.shippingMessage
		hideReviews: -> if @product?.hideReviews? then return @product.hideReviews

	methods:
		updateCurrentVariant: (e) -> @currentVariant = event

		onScroll: ->
			# Sync page scrollTop to sidebar scrollTop
			@$refs.contents.scrollTop = @scroller.scrollTop - 80

		purchaseTypeChange: (val) -> @purchaseType = val

	mounted: ->
		@scroller = document.querySelector 'html'
		document.addEventListener 'scroll', @onScroll

	beforeDestroy: -> document.removeEventListener 'scroll', @onScroll


